export default __webpack_public_path__ + "static/media/IranianSans.8c2ed8fb.ttf";